import { z } from 'zod';
export * from './constants';
export * from './filterExploreByTags';
export * from './followUpTools';
export * from './requestTypes';
export * from './schemas';
export * from './types';
export * from './utils';
export const baseAgentSchema = z.object({
    uuid: z.string(),
    projectUuid: z.string(),
    organizationUuid: z.string(),
    name: z.string(),
    description: z.string(),
    imageUrl: z.string().url().nullable(),
    tags: z.array(z.string()).nullable(),
    integrations: z.array(
    // z.union([
    // TODO: once we add more integrations, we should use union
    z.object({
        type: z.literal('slack'),
        channelId: z.string(),
    })),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    instruction: z
        .string()
        .max(8192, // 8kb
    'Custom instruction is too long. Maximum allowed is 8,100 characters.')
        .nullable(),
    provider: z.string(),
    model: z.string(),
});
//# sourceMappingURL=index.js.map